import React, { useMemo } from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { SpectrogramPoint } from '@ledium/types';
import { WavelengthChart } from '@ledium/ui-common';
import { Grid } from '@mui/material';

const LightChannelChart = () => {
    const {
        pageState: { formData }
    } = usePageStore();
    const spectrogram = formData.spectrogram as SpectrogramPoint[];

    const yAxis = useMemo(() => {
        const dataMax = Math.max(...spectrogram.map((p) => p.irradiance ?? 0));
        if (dataMax <= 0) {
            return undefined;
        }
        const precision = Math.max(1, -Math.floor(Math.log10(dataMax)));
        const factor = Math.pow(10, precision);
        return Math.ceil(dataMax * factor) / factor;
    }, [spectrogram]);

    if (!spectrogram.length) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <WavelengthChart data={spectrogram} yAxis={yAxis} />
        </Grid>
    );
};

export default LightChannelChart;
